module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"privacyText":"We take your privacy seriously. You have full control over what calendars and information you choose to share."}}')
  delete Component.options._Ctor
}
